import * as React from 'react';
import Result from './Result';
import { Exhibit } from '../../../../interfaces/models';
import { EntityResultsBaseProps } from '../EntityResults';

interface ExhibitResultProps extends EntityResultsBaseProps<Exhibit> {
  result: Exhibit;
}

const ExhibitResult: React.FC<ExhibitResultProps> = (props) => {
  const { id, title } = props.result;

  return (
    <Result
      title={title}
      subTitle={`Exhibit: ${id}`}
      entity={props.result}
      onAddEntity={props.onAddEntity}
      onClearResults={props.onClearResults}
    />
  );
};

export default ExhibitResult;
